import { di } from 'react-magnetic-di';

type DraftBuild = {
	draftContent: string;
};

export async function fetchDraftBuild(buildId: string, workspaceId: string): Promise<DraftBuild> {
	di(fetch);

	const response = await fetch(
		`/gateway/studio/workspace/${workspaceId}/api/studio/solution-architect/draft-build/${buildId}`,
		{ credentials: 'include' },
	);

	if (!response.ok) {
		throw new Error('Failed to fetch draft build.');
	}

	return response.json();
}
